export default __webpack_public_path__ + "static/media/logo-deskop.f51be225.svg";